document.querySelectorAll('.slider-video-carousel .slider').forEach(function(slider) {
    //if (!slider.classList.contains('flickity-enabled')) {
        new Flickity(slider, {
            wrapAround: false,
            cellAlign: "center",
            dragThreshold: 10, 
            touchVerticalScroll: false,
            contain: true,
            resize: true,
            groupCells: true,
            prevNextButtons: true,
            pageDots: false,
            arrowShape: "M50.1228 1.62718C48.1063 -0.542395 44.8369 -0.542395 42.8204 1.62718L1.51235 46.0716C-0.504121 48.2412 -0.504121 51.7588 1.51235 53.9284L42.8204 98.3728C44.8369 100.542 48.1063 100.542 50.1228 98.3728C52.1392 96.2032 52.1392 92.6857 50.1228 90.5161L17.6293 55.5556H94.8365C97.6882 55.5556 100 53.0682 100 50C100 46.9317 97.6882 44.4444 94.8365 44.4444H17.6293L50.1228 9.48393C52.1392 7.31435 52.1392 3.79676 50.1228 1.62718Z"
        });
  //  }
});
 



